import { render, staticRenderFns } from "./key-contacts-container.vue?vue&type=template&id=0fd9ee2b"
import script from "./key-contacts-container.vue?vue&type=script&lang=js"
export * from "./key-contacts-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd9ee2b')) {
      api.createRecord('0fd9ee2b', component.options)
    } else {
      api.reload('0fd9ee2b', component.options)
    }
    module.hot.accept("./key-contacts-container.vue?vue&type=template&id=0fd9ee2b", function () {
      api.rerender('0fd9ee2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/contact/components/key-contacts-container.vue"
export default component.exports